import * as React from "react";
const PreLiveTeam = (props) => {
    return (React.createElement("div", { className: `rj-scoreboard__pre-live-teams rj-scoreboard__pre-live-teams--${props.position}`, "data-uat": `scoreboard-pre-live-team-${props.position}` },
        React.createElement("span", { className: `rj-scoreboard__pre-live-border rj-scoreboard__pre-live-border--${props.position}` }),
        React.createElement("span", { className: `rj-scoreboard__pre-live-team-name rj-scoreboard__pre-live-team-name--${props.position}` }, props.teamName)));
};
export const PreLiveTeamLeft = (props) => {
    return React.createElement(PreLiveTeam, { position: "left", teamName: props.teamName });
};
export const PreLiveTeamRight = (props) => {
    return React.createElement(PreLiveTeam, { position: "right", teamName: props.teamName });
};
//# sourceMappingURL=PreLiveTeam.js.map